import React from 'react'
import Head from '../components/Head'
import Header from '../components/Header'
import Intro from '../components/IntroCareers'
import BiColumn__careers from '../components/biColumn__careers'
import TriColumn from '../components/triColumn__benefits'
import TriColumn__press from '../components/triColumn__press--white'
import Card from '../good_components/Card'
import Footer from '../components/footer'

const careers = require('../data/careers.json')

export default class extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Head
          title="PlayVS | Careers"
          description="PlayVS is the official high school esports league, sanctioned by the NFHS. Play with your friends, compete for your school, and win the state championship."
          keywords="high school esports"
        />

        <Header />

        <Intro />

        <BiColumn__careers />

        <TriColumn />

        <TriColumn__press />

        <section>
          <div className="section__head">
            <h2>Available Positions</h2>
            <p>
              At PlayVS, we put a heavy emphasis on inclusiveness, diversity, and most importantly, player
              experience. Our team is curious, scrappy and incredibly talented. If that sounds like you, we
              look forward to your application.
            </p>
          </div>
          <div className="section__body">
            <div className="row">
              {careers.map(career => {
                return (
                  <Card className="column--fourth contained centered">
                    <div className="meta centered">
                      <i className={`bx ${career.icon}`} />
                      <div className="h7">{career.title}</div>
                      <a href={career.link} target="_blank" rel="nofollow">
                        Apply
                      </a>
                    </div>
                  </Card>
                )
              })}
            </div>
          </div>
        </section>

        <Footer />
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/ui/pages/careers.js